import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { INPUT, BTN_PRIMARY, BTN_OUTLINE, Toggle, Field } from "components/admin/AdminUI";
import api from "lib/api";

export default function CrawlerForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;

  const [ip, setIp] = useState("");
  const [hostname, setHostname] = useState("");
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(isEditing);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isEditing) return;
    api
      .get(`/admin/crawlers/${id}/`)
      .then(({ data }) => {
        setIp(data.ip || "");
        setHostname(data.hostname || "");
        setDescription(data.description || "");
        setIsActive(data.is_active ?? true);
      })
      .catch(() => setError("Erro ao carregar IP."))
      .finally(() => setFetching(false));
  }, [id, isEditing]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const payload = { ip, hostname, description, is_active: isActive };
      if (isEditing) await api.put(`/admin/crawlers/${id}/`, payload);
      else await api.post("/admin/crawlers/", payload);
      navigate("/admin/crawlers");
    } catch (err) {
      const detail = err.response?.data;
      setError(typeof detail === "object" ? Object.values(detail).flat().join(" ") : "Erro ao salvar.");
    } finally {
      setLoading(false);
    }
  }

  if (fetching) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={() => navigate("/admin/crawlers")}
        className="mb-4 flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" /> Voltar para Crawlers
      </button>

      <h1 className="mb-1 text-2xl font-bold tracking-tight">{isEditing ? "Editar IP" : "Novo IP"}</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        {isEditing ? "Altere os dados do IP de varredura." : "Cadastre um IP/CIDR de varredura."}
      </p>

      <div className="w-full rounded-lg border border-border bg-card p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field label="IP ou CIDR">
            <input className={INPUT} value={ip} onChange={(e) => setIp(e.target.value)} placeholder="203.0.113.0/24" required autoFocus />
          </Field>
          <Field label="Hostname">
            <input className={INPUT} value={hostname} onChange={(e) => setHostname(e.target.value)} placeholder="scan.securityscan.com.br" />
          </Field>
          <Field label="Descrição">
            <input className={INPUT} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="descrição opcional" />
          </Field>
          <Toggle checked={isActive} onChange={setIsActive} label="Ativo" description="Exibe o IP na página pública /scan." />

          {error && <p className="text-sm text-red-500">{error}</p>}

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" className={BTN_OUTLINE} onClick={() => navigate("/admin/crawlers")}>
              Cancelar
            </button>
            <button type="submit" className={BTN_PRIMARY} disabled={loading}>
              {loading ? "..." : isEditing ? "Salvar" : "Criar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
